import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "88",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--td-component-border)",
      d: "M0 0h88v48H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--td-text-color-primary)",
      d: "M42.863 14.052v2.708h1.625v-2.708z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--td-text-color-primary)",
      "fill-rule": "evenodd",
      d: "M38.349 23.982a5.326 5.326 0 1 1 10.653 0 5.326 5.326 0 0 1-10.653 0m5.326-3.701a3.701 3.701 0 1 0 0 7.403 3.701 3.701 0 0 0 0-7.403M52.208 26.781h-2.621l-2.06 6.699 1.552.478.511-1.661h2.614l.511 1.66 1.554-.477zm-.503 3.89-.697-2.265h-.221l-.697 2.266z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--td-text-color-primary)",
      d: "m48.208 18.3 1.915-1.914 1.149 1.15-1.915 1.914zM53.606 23.17h-2.709v1.625h2.709zM44.488 31.205v2.708h-1.625v-2.708zM37.228 31.579l1.915-1.915-1.15-1.15-1.914 1.916zM36.453 24.795h-2.708V23.17h2.708zM36.079 17.535l1.915 1.915 1.149-1.15-1.915-1.914z"
    }, null, -1)
  ])))
}
export default { render: render }